import { CaseTypeRepository } from '@telespot/domain';

export interface ICountCaseTypesByMethodTypeQuery {
  /**
   * Counts case types that reference the given method type.
   * Repository errors propagate so the caller can apply its own fallback.
   */
  execute(methodTypeId: string): Promise<number>;
}

export class CountCaseTypesByMethodTypeQuery implements ICountCaseTypesByMethodTypeQuery {
  constructor(private readonly caseTypeRepository: CaseTypeRepository) {}

  public async execute(methodTypeId: string): Promise<number> {
    return this.caseTypeRepository.countByMethodType(methodTypeId);
  }
}
